<template>
  <div id="engine-data-details" ref="engineDataDetails">
    <div
      id="engin-data-details-main-container"
      class="overflow-auto"
      style="position: relative; width: 100%"
      ref="mainContainer"
    >
      <div class="engine-chart-table">
        <div
          id="chart-column-header"
          class="flex"
          v-if="all_channel_data.length > 0"
        >
          <div
            class="
              column-header-text column-handle-btn
              aisea-text-12-600-dark-gray
              flex
              justify-start
              pl-6
              flex-shrink-0
            "
            v-show="selectedChannelOriginId === 'custom'"
            style="width: 27px"
          ></div>
          <div
            class="
              column-header-text column-channel-id
              aisea-text-12-600-dark-gray
              flex
              justify-start
              pl-6
            "
          >
            タグID
          </div>
          <div
            class="
              column-header-text column-channel-name
              aisea-text-12-600-dark-gray
              flex
              justify-start
              pl-6
              flex-shrink-0
            "
          >
            項目名
          </div>
          <div
            class="
              column-header-text column-value
              aisea-text-12-600-dark-gray
              flex
              justify-start
              pl-6
              ml-auto
            "
          >
            数値/状態
          </div>
          <div
            class="
              column-header-text column-chart
              aisea-text-12-600-dark-gray
              flex
              justify-start
              pl-6
              mr-6
            "
          >
            {{ xAxisValueDisp }}
          </div>
        </div>

        <div
          id="engine-data-chart-area"
          class="overflow-y-auto"
          refs="chartArea"
        >
          <engine-data-chart
            :channel_data="all_channel_data"
            :xAxisValue.sync="xAxisValue"
            :showNormalValue="showNormalValue"
            :showAbnormalValue="showAbnormalValue"
            :deviceType="deviceType"
            @refreshChannelData="refreshChannelData"
            ref="child"
          >
          </engine-data-chart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EngineDataChart from "./EngineDataChart";
import {createNamespacedHelpers} from "vuex";
const { mapGetters, mapActions, mapState } = createNamespacedHelpers("enterpriseVesselMonitoringEngine");
import { DeviceInfoMixin, ColorMixin } from "@/mixins";
import moment from "moment";

export default {
  name: "engineDataDetails",
  props: ["deviceType"],
  components: {
    EngineDataChart,
  },
  mixins: [DeviceInfoMixin, ColorMixin],
  data() {
    return {
      all_channel_data:[], //このデータがAPIから返ってくる想定
      isProcessing: false,
      showNormalValue: true,
      showAbnormalValue: true,
      xAxisValue: 0,
    }
  },
  computed: {
    ...mapGetters([ "getSelectedChannelGroupId", ]),
    ...mapState({
      selectedChannelOriginId: (state) => state.selectedChannelOriginId,
    }),
    xAxisValueDisp() {
      if (!this.xAxisValue) return "";
      let time = moment(this.xAxisValue).local().format("YYYY/MM/DD HH:mm:ss");
      return time;
    },
  },
  watch: {
    deviceType() {
      this.setRowHeight();
    },
    xAxisValue() {
      this.setChannelGroupFocusPoint({
        channelGroup: this.getSelectedChannelGroupId,
        time: this.xAxisValue, 
      });
    },
    onChangeWindowSize() {
      this.onResize();
    },
  },
  methods: {
    ...mapActions([
      "setChannelGroupFocusPoint",
      "getChannelDetailData",
    ]),

    /**
     *  一覧再表示.
     */
    refreshChannelData() {
      if ( this.isProcessing === true ) {
        return;
      }
      this.isProcessing = true;
      this.$vs.loading({
        text: "データ取得中",
        textAfter: true,
        color: this.AISEA_COLOR.BLUE,
        container: '#content-area',
      });

      this.$nextTick(async () => {
        this.all_channel_data = [];
        this.$refs.child.clearDisplayMap(); // ライブで取得した値に残っているデータをクリア

        this.all_channel_data = await this.getChannelDetailData();

        this.$vs.loading.close('#content-area > .con-vs-loading')
        this.isProcessing = false;
      });
    },

    onResize() {
      const mainContainerElement = document.getElementById(
        "engine-data-details",
      );
      if (mainContainerElement) {
        const mainContainerRect = mainContainerElement.getBoundingClientRect();
        const bottomBuffer = !this.isIPhone
          ? 25
          : this.getDeviceInfo().deviceOrientation === "portrait"
          ? 90
          : 30;
        mainContainerElement.style["height"] =
          document.documentElement.clientHeight -
          mainContainerRect.top -
          bottomBuffer +
          "px";
      }
    },

    setRowHeight() {
      const mainContainer = this.$refs.mainContainer;
      const rowHeight = this.deviceType === "iPhone" ? 70 : 80;
      mainContainer.style.setProperty("--row-height", `${rowHeight}px`);
    },

  },
  mounted() {
    this.onResize();
    this.setRowHeight();
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

#engine-data-details{
  color: $aisea-gray-black;
  display: flex;
  padding: 0 16px;

  #engin-data-details-main-container {
    // header
    --column-header-hight: 52px;
    --row-height: 80px;
    // row
    --column-channel-id-min-width: 94px;
    --column-channel-chart-min-width: 423px;
    width: 100%;
  }

  .engine-chart-table {
    width: 100%;
    @media screen and (min-width: 768px) and (min-height: 376px) {
      min-width: 100%;
      width: fit-content;
    }
  }
  #chart-column-header {
    display: none;
    width: 100%;
    z-index: 4;
    @media screen and (min-width: 768px) and (min-height: 376px) {
      min-width: fit-content;
      display: flex;
      border-bottom: 1px solid #e2e2e2;

      padding: 1rem 0 0 0;
      position: sticky;
      top: 0;
      background-color: $aisea-pure-white;
    }

    .column-header-text {
      color: $aisea-gray;
      align-items: center;
      height: var(--column-header-hight);
      @media screen and (min-width: portrait) {
      }
    }
    .column-value {
      width: 50%;
      @media screen and (min-width: 667px) {
        min-width: 280px;
        max-width: 280px;
        padding-left: 1.5rem;
        justify-content: flex-start;
      }
    }
  }

  #engine-data-chart-area {
    width: 100%;
    padding: 0;
    margin: 0;
    overflow: visible;
  }

  .column-handle-btn {
    display: none;
    @media screen and (min-width: 768px) and (min-height: 376px) {
      display: inline-flex;
      width: 30px;
      padding: 0;
      justify-content: center;
    }
  }

  .column-channel-id {
    min-width: var(--column-channel-id-min-width);
    max-width: var(--column-channel-id-min-width);
  }
  .column-channel-name {
    width: calc(100% - 170px);
    @media screen and (min-width: 667px) {
      width: calc(100% - 170px - 90px);
      min-width: 200px;
      max-width: unset;
      padding-left: 1.5rem;
      justify-content: flex-start;
      flex-shrink: unset;
    }
    @media screen and (min-width: 768px) and (min-height: 376px) {
      width: 50%;
      padding-left: 1.5rem;
      padding-right: 1.5rem;
      justify-content: flex-start;
      width: unset;
      flex-grow: 1;
    }
  }
  .column-value {
    width: 50%;
    max-width: 140px;
    min-width: 140px;
    @media screen and (min-width: 768px) and (min-height: 376px) {
      min-width: 280px;
      max-width: 280px;
      padding-left: 1.5rem;
      justify-content: flex-start;
    }
  }
  .column-chart {
    min-width: var(--column-channel-chart-min-width);
    width: 423px;
    display: none;
    @media screen and (min-width: 768px) and (min-height: 376px) {
      display: flex;
    }
  }
}
</style>
